import * as React from "react"
import { useHistory, useLocation } from "react-router-dom"

import { accountSettingsTabPath } from "@/constants/accountSettingsSidebar"
import { CONNECT_BROKER_WIZARD_OPEN_QUERY } from "@/views/Dashboard/Profile/connectBroker/connectBrokerWizardConstants"

/**
 * Legacy `/profile/broker-api/connect` entry — redirects onto Broker Management
 * with `connect=1` so the connect dialog opens in place.
 */
export default function ConnectBrokerWizardPage(): null {
  const history = useHistory()
  const location = useLocation()

  React.useEffect(() => {
    const sp = new URLSearchParams(location.search)
    sp.set(CONNECT_BROKER_WIZARD_OPEN_QUERY, "1")
    const qs = sp.toString()
    history.replace(`${accountSettingsTabPath("broker-api")}?${qs}`)
  }, [history, location.search])

  return null
}

export { CONNECT_BROKER_WIZARD_PATH } from "@/views/Dashboard/Profile/connectBroker/connectBrokerWizardConstants"
